/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "depot-pricing-management",
	data() {
		return {
			depotProducts: [],
			depotProductHeadings: [
				{
					text: "#",
					field: "productId"
				},
				{
					text: "Depot",
					field: "depot"
				},
				{
					text: "Name",
					field: "product"
				},
				{
					text: "Price",
					field: "priceAsString"
				},
				{
					text: "Is Active",
					field: "isActive"
				},
				{
					text: "Date Created",
					field: "insertedOn"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			depots: [],
			actionKeys:{
				updatePricing: "updatePricing",
				markAsActiveInactive: "markAsActiveInactive",
			},
			updatePricingFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "updatePricingModal",
				heading: "Update Pricing",
				depotProduct: {
					productId: null,
					depotProductId: null,
					activeFromDate: new Date(),
					price: null,
					depotId: null,
					isActive: null,
					effectiveDateErrorMessage: null,
					depotErrorMessage: null,
					priceErrorMessage: null
				}
			},
			depotPricingMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveModal",
				heading: "Mark Depot Price As Active/Inactive",
				isActive: null
			},
			depotManageProductsModal:{
				showModal: false,
				isSaving: false,
				modalId: "manageDepotProductsModal",
				heading: "Manage Depot Products",
				depotId: null
			},
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				depotId: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getDepots(){
			this.loading = true;
			let request = {
				isActive: true,
				provinceId: 0
			};
			systemService.getAllDepots(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depots = successResponse.data.result;
						this.depots = $.map(this.depots,
							function (obj) {
								obj.id = obj.id || obj.depotId;
								obj.text = obj.text || obj.name;
								return obj;
							});
						this.depots.unshift({
							depotId: 0,
							id: 0,
							text: "All"
						});
						this.depots = dataTableHelper.castFieldValues(this.depots);
						this.filter.depotId = this.depots[0].depotId;
						this.getDepotProducts();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDepotProducts(){
			this.loading = true;
			let request = {
				depotId: this.filter.depotId,
				searchQuery: this.filter.customerSearchQuery,
				pageNum: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
			};
			orderService.getDepotProductPrices(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depotProducts = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						this.filterStateChanged = false;
						for(let i = 0; i < this.depotProducts.length; i++) {
							this.depotProducts[i].priceAsString = currencyHelper.numberToCurrency(this.depotProducts[i].price);
							this.depotProducts[i].actions = [
								{
									name: "Update Pricing",
									key: this.actionKeys.updatePricing
								},
								{
									name: this.depotProducts[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive
								}
							];
						}
						this.depotProducts = dataTableHelper.castFieldValues(this.depotProducts);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onDepotFilterSelect(depot){
			if(this.filter.depotId !== depot.id){
				this.filterStateChanged = true;
			}
			this.filter.depotId = depot.id;
		},
		onPagingUpdated(pagingInfo){
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getDepotProducts();
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			//TODO: filter customer results
			this.getDepotProducts();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onManageProductsClick(){
			this.depotManageProductsModal.showModal = true;
			this.depotManageProductsModal.heading = "Manage Products";
			this.depotManageProductsModal.depotId = this.filter.depotId;
		},
		onManageDepotProductsModalOkClicked(){
			this.depotManageProductsModal.showModal = false;
			this.getDepotProducts();
		},
		onProductActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			if(actionAndData.action === this.actionKeys.updatePricing){
				this.updatePricingFormModal.showModal = true;
				this.updatePricingFormModal.depotProduct.productId = actionAndData.data.productId;
				this.updatePricingFormModal.depotProduct.depotProductId = actionAndData.data.depotProductPriceId;
				this.updatePricingFormModal.depotProduct.price = actionAndData.data.price;
				this.updatePricingFormModal.depotProduct.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
				this.updatePricingFormModal.depotProduct.depotId = actionAndData.data.depotId;
				this.updatePricingFormModal.heading = "Update Pricing For Depot - " + actionAndData.data.depot + " and Product - " + actionAndData.data.product;
			}
			if(actionAndData.action === this.actionKeys.markAsActiveInactive){
				this.depotPricingMarkAsActiveInactiveModal.showModal = true;
				this.depotPricingMarkAsActiveInactiveModal.depotProductId = actionAndData.data.depotProductPriceId;
				this.depotPricingMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
				this.depotPricingMarkAsActiveInactiveModal.heading = "Mark Depot Price for Depot - " + actionAndData.data.depot + " and Product - " + actionAndData.data.product + (this.depotPricingMarkAsActiveInactiveModal.isActive ? " As Inactive" : " As Active");
			}
		},
		onMarkDepotPricingActiveInactiveSelected(isActive){
			this.depotPricingMarkAsActiveInactiveModal.isActive = isActive;
			console.log("depotPricingMarkAsActiveInactiveModal.isActive", this.depotPricingMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.depotPricingMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				depotProductPriceId: this.depotPricingMarkAsActiveInactiveModal.depotProductId,
				isActive: markAsActive
			};
			orderService.markDepotProductPriceAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depotPricingMarkAsActiveInactiveModal.showModal = false;
						this.getDepotProducts();
					}
					this.depotPricingMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.depotPricingMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onNewPriceActiveFromSelected(date) {
			this.updatePricingFormModal.depotProduct.activeFromDate = date;
		},
		onUpdatePricingModalCloseClick(){
			this.updatePricingFormModal.showModal = false;
			this.clearDepotProductModel();
		},
		onUpdatePricingModalSaveClick(){
			this.updatePricingFormModal.isSaving = true;
			let request = {
				depotProductPriceId: this.updatePricingFormModal.depotProduct.depotProductId,
				productId: this.updatePricingFormModal.depotProduct.productId,
				depotId: this.updatePricingFormModal.depotProduct.depotId,
				price: this.updatePricingFormModal.depotProduct.price,
				effectiveDate: this.updatePricingFormModal.depotProduct.activeFromDate,
				isActive: this.updatePricingFormModal.depotProduct.isActive
			}
			orderService.addOrUpdateDepotProductPrice(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.depotProductPriceValidationResponse.valuesAreValid){
							this.updatePricingFormModal.showModal = false;
							this.clearDepotProductModel();
							this.getDepotProducts();
						}
						else{
							this.updatePricingFormModal.depotProduct.effectiveDateErrorMessage = successResponse.data.depotProductPriceValidationResponse.effectiveDateValidationResponse.message;
							this.updatePricingFormModal.depotProduct.depotErrorMessage = successResponse.data.depotProductPriceValidationResponse.depotValidationResponse.message;
							this.updatePricingFormModal.depotProduct.priceErrorMessage = successResponse.data.depotProductPriceValidationResponse.pricingValidationResponse.message;
						}
					}
					this.updatePricingFormModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.updatePricingFormModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearDepotProductModel(){
			this.updatePricingFormModal.depotProduct = {
				productId: null,
				depotProductId: null,
				activeFromDate: new Date(),
				price: null,
				isActive: null,
				depotId: null,
				effectiveDateErrorMessage: null,
				depotErrorMessage: null,
				priceErrorMessage: null
			};
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Depot pump prices");
			var breadcrumbs = [];
			var breadcrumbLogistics = {
				url: null,
				displayText: "Pricing"
			};
			var driverManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Depot pump prices"
			};
			breadcrumbs.push(breadcrumbLogistics);
			breadcrumbs.push(driverManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getDepots();
	}
};